module.exports = __webpack_public_path__ + "img/upload_zodiac_2.3d60ac84.webp";